module.exports = __webpack_public_path__ + "img/male.e7129d9e.png";